import Axios from "axios";
import {POST_DOCUMENT_AS_MESSAGE, POST_MESSAGE} from "../actions/chatCase/form";
import {
    clearListMessages,
    GET_MESSAGES,
    getMessages,
    saveMessages,
    UPDATE_UNREAD_MESSAGES
} from "../actions/chatCase/messages";
import {setRedirection} from "../actions/user";
import {getSession} from "../common/session.service";
import {getApiBaseUrl} from "../utils/baseUrl";
import {setErrorApiMessage} from "../actions/apiFlag";

// On définit par défaut un TimeOut Axios à 10 seconde au bout desquelles un code erreur "ECONNABORTED" est envoyé (code que l'on peut .catch dans une promesse)
// et qui permet donc de définir un message d'erreur en cas de non réponse de l'API
Axios.defaults.timeout = 1000000;

const cases = (store) => (next) => (action) => {
    switch (action.type) {
        // Action permettant d'inscrire le message poster par le user en BDD
        case POST_MESSAGE : {
            // Destructuring du state global
            const state = store.getState();
            const {chatCase} = state;

            const url = `${getApiBaseUrl()}/postMessages/`;

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "idCase": chatCase.idCase, // On associe le message à l'id du cas
                "message": {
                    "idUser": window.localStorage.idUser,
                    "idCareManager": 0, // 0 parce que c'est un message provenant du user
                    "status": 0, // status 0 = message non lu
                    "content": chatCase.messageValue.message // Le contenu du message
                }
            };
            Axios.post(url, payload)
                .then(() => {
                    // Une fois le message posté, on récupère à nouveau les messages
                    store.dispatch(getMessages());
                })
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err) {
                        if (err.code === "ECONNABORTED") {
                            store.dispatch(setErrorApiMessage(true));
                        }
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });

            next(action);
            break;
        }
        // Action permettant d'inscrire un message de type document en BDD et d'afficher la bulle document dans la liste des messages
        // Cet affichage est conditionné par l'existence d'un idDocument (idDocument != 0)
        case POST_DOCUMENT_AS_MESSAGE : {
            // Destructuring du state global
            const state = store.getState();
            const {chatCase} = state;

            const url = `${getApiBaseUrl()}/postMessages/`;

            // https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Global_Objects/Object/values
            const arrayOfValue = Object.values(action.id); // Renvoie un tableau contenant le/les id(s) du/des document(s)

            // Pour chaque documents, on créé un payload avec les informations demandé par l'API puis on exécute la requête
            arrayOfValue.map((id) => {
                const payload = {
                    "session": {
                        "id": window.localStorage.id,
                        "idUser": window.localStorage.idUser,
                        "email": window.localStorage.email,
                    },
                    "idCase": chatCase.idCase,
                    "message": {
                        "idUser": window.localStorage.idUser,
                        "idCareManager": 0,
                        "idDocument": id,
                        "status": 0,
                        "content": ""
                    }
                };
                Axios.post(url, payload)
                    .catch((err) => {
                        if (err.response.status === 401) {
                            store.dispatch(setRedirection(true));
                        }
                        if (err) {
                            if (err.code === "ECONNABORTED") {
                                store.dispatch(setErrorApiMessage(true));
                            }
                            setTimeout(() => {
                                store.dispatch(setErrorApiMessage(false));
                            }, 5000);
                        }
                    });
            });
            next(action);
            break;
        }
        // Action permettant de récuperer la liste des messages et de mettre à jour le composant qui affiche les messages
        // s'il y en a des nouveaux qui ont été posté le caremanager
        case GET_MESSAGES : {
            // Destructuring du state global
            const state = store.getState();
            const {chatCase} = state;

            const url5 = `${getApiBaseUrl()}/getMessages/`;

            const Payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "idCase": chatCase.idCase
            };

            Axios.post(url5, Payload)
                .then((res) => {
                    if (res.data.status === "success") {
                        if (res.data.listMessages === null) {
                            store.dispatch(clearListMessages());
                            store.dispatch(saveMessages([]));
                        }
                            // Ici on compare la longueur du tableau de messages renvoyé par la requête
                            // avec le tableau de message stocké dans notre state. Si les deux tableaux ont une longueur différentes
                            // cela signifie que qu'il y a des nouveaux messages inscrits en BDD qui ont été postés par un CareManager
                        // et qu'il faut mettre à jour ces messages dans notre state global
                        else if (chatCase.messages.length !== res.data.listMessages.length) {
                            // Ici on sauvegarde le nouveau tableau provenant de requête API
                            // Cela aura pour effet de mettre à jour notre composant affichant les messages
                            store.dispatch(saveMessages(res.data.listMessages));
                        }
                    }
                })
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err) {
                        if (err.code === "ECONNABORTED") {
                            store.dispatch(setErrorApiMessage(true));
                        }
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });
            next(action);
            break;
        }
        // Action permettant de mettre à jour les messages non lus -> message lu (state 0 -> state 1)
        case UPDATE_UNREAD_MESSAGES : {
            const url = `${getApiBaseUrl()}/updateMessage/`;
            // Destructuring du state
            const state = store.getState();
            const {chatCase} = state;
            const {messages} = chatCase;

            // Récupération de la session
            const sessionObj = getSession();
            const {session} = sessionObj;

            // On filtre les messages pour récupérer les messages des CareManager qui n'ont pas été encore vu par le user (status 0 = non vu)
            const filteredList = messages.filter((i) => i.status == 0 && i.idCareManager != 0);

            filteredList.map((mess) => {
                // Pour chaque message non vu, on update son status
                const payload = {
                    session,
                    "idMessage": mess.id,
                    "toUpdate": {
                        "status": 1 // status 1 = vu
                    }
                };
                Axios.post(url, payload)
                    .catch((err) => {
                        if (err.response.status === 401) {
                            store.dispatch(setRedirection(true));
                        }
                        if (err) {
                            if (err.code === "ECONNABORTED") {
                                store.dispatch(setErrorApiMessage(true));
                            }
                            setTimeout(() => {
                                store.dispatch(setErrorApiMessage(false));
                            }, 5000);
                        }
                    });
            });
            next(action);
            break;
        }
        default:
            next(action);
    }
};

export default cases;